import Repository from '../repository';

const resource = '/page';

export default {
  homepage() {
    return {
      slideshows(params = {}) {
        return Repository.get(`${resource}/homepage/slideshows`, { params });
      },
    };
  },
  contact() {
    return {
      submit(data) {
        return Repository.post(`${resource}/contact/submit_form`, data);
      },
    };
  },
};
